import React, { useState, useEffect, useRef } from "react";
import { makeStyles } from "@material-ui/core";
import { useForm, Form } from "../../components/customHelpers/useForm";
import Controls from "../../components/controls/Controls";
import { PurchaseOrder } from "../../actions/purchaseOrder";
import produce from "immer";
import { Grid } from "@mui/material";
const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiFormControl-root": {
      width: "100%",
      margin: theme.spacing(1),
    },
  },
}));

const initialFValues = {
  name: "",
};

export default function PurchaseOrderForm({
  recordForEdit,
  setOpenPopup,
  setPurchaseOrders,
  NotifyMessage,
}) {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const { addPurchaseOrder, updatePurchaseOrder } = PurchaseOrder();
  const validate = (fieldValues = values) => {
    let temp = { ...errors };
    if ("name" in fieldValues)
      temp.name = fieldValues.name ? "" : "This field is required.";
    setErrors({
      ...temp,
    });

    if (fieldValues === values)
      return Object.values(temp).every((x) => x === "");
  };

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialFValues, true, validate);

  useEffect(() => {
    if (recordForEdit) {
      setValues({
        ...recordForEdit,
      });
    }
  }, [recordForEdit, setValues]);
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      setLoading(true);
      if (recordForEdit) {
        updatePurchaseOrder(recordForEdit.id, values)
          .then((response) => {
            if (response.err) {
              NotifyMessage({
                message: response.err,
                type: "error",
              });
            } else {
              NotifyMessage({
                message: "Purchase order updated successfully",
                type: "success",
              });
              setOpenPopup(false);
              resetForm();
              setPurchaseOrders(
                produce((draft) => {
                  const index = draft.findIndex(
                    (purchaseOrder) => purchaseOrder.id === recordForEdit.id
                  );

                  if (index !== -1) draft[index] = response.purchaseOrder;
                })
              );
            }
          })
          .catch((err) => {
            NotifyMessage({
              message: "Failed to update purchase order",
              type: "error",
            });
          })
          .finally(() => {
            setLoading(false);
          });
      } else {
        addPurchaseOrder(values)
          .then((response) => {
            if (response.err) {
              NotifyMessage({
                message: response.err,
                type: "error",
              });
            } else {
              NotifyMessage({
                message: "Purchase order added successfully",
                type: "success",
              });
              resetForm();

              setOpenPopup(false);
              setPurchaseOrders(
                produce((draft) => {
                  draft.unshift({ ...response.purchaseOrder });
                })
              );
              resetForm();
            }
          })
          .catch((err) => {
            NotifyMessage({
              message: "Failed to add purchase order",
              type: "error",
            });
          })
          .finally(() => {
            setLoading(false);
          });
      }
    }
  };
  const firstFieldRef = useRef(null);
  useEffect(() => {
    if (firstFieldRef.current) {
      firstFieldRef.current.focus();
    }
  }, []);
  return (
    <Form onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Controls.Input
            name="name"
            label="Name"
            value={values.name}
            onChange={handleInputChange}
            error={errors.name}
            inputRef={firstFieldRef}
          />
        </Grid>
        <Grid item xs={12} md={6}></Grid>
        <Grid item xs={12}>
          <Controls.Button
            type="submit"
            text={recordForEdit ? "Update" : "Submit"}
            disabled={loading}
          />
          <Controls.Button
            text="Cancel"
            color="default"
            onClick={() => {
              setOpenPopup(false);
              resetForm();
            }}
            disabled={loading}
          />
        </Grid>
      </Grid>
    </Form>
  );
}
